module.exports = __webpack_public_path__ + "img/white_time.e8e4d3b7.svg";